import { Chain } from '@bifrost-platform/bifront-sdk-react-biholder';
import DEFAULT_BLOCK_TERM from '@/configs/defaultValue/defaultBlock';
import {
  TESTNET_CHAIN_API_ID_BIFROST,
  TESTNET_CHAIN_API_ID_ETHEREUM,
  TESTNET_CHAIN_API_ID_BSC,
  TESTNET_CHAIN_API_ID_POLYGON,
  TESTNET_CHAIN_API_ID_ARBITRUM,
  TESTNET_CHAIN_API_ID_BASE,
} from './chainApiId';
import {
  TESTNET_CHAIN_EXPLORER_URL_BIFROST,
  TESTNET_CHAIN_EXPLORER_URL_ETHEREUM,
  TESTNET_CHAIN_EXPLORER_URL_BSC,
  TESTNET_CHAIN_EXPLORER_URL_POLYGON,
  TESTNET_CHAIN_EXPLORER_URL_ARBITRUM,
  TESTNET_CHAIN_EXPLORER_URL_BASE,
} from './chainExplorerUrl';
import {
  TESTNET_CHAIN_ID_BIFROST,
  TESTNET_CHAIN_ID_ETHEREUM,
  TESTNET_CHAIN_ID_BSC,
  TESTNET_CHAIN_ID_POLYGON,
  TESTNET_CHAIN_ID_ARBITRUM,
  TESTNET_CHAIN_ID_BASE,
} from './chainId';
import {
  TESTNET_CHAIN_NAME_BIFROST,
  TESTNET_CHAIN_NAME_ETHEREUM,
  TESTNET_CHAIN_NAME_BSC,
  TESTNET_CHAIN_NAME_POLYGON,
  TESTNET_CHAIN_NAME_ARBITRUM,
  TESTNET_CHAIN_NAME_BASE,
} from './chainName';
import {
  TESTNET_CHAIN_RPC_URLS_BIFROST,
  TESTNET_CHAIN_RPC_URLS_ETHEREUM,
  TESTNET_CHAIN_RPC_URLS_BSC,
  TESTNET_CHAIN_RPC_URLS_POLYGON,
  TESTNET_CHAIN_RPC_URLS_ARBITRUM,
  TESTNET_CHAIN_RPC_URLS_BASE,
} from './chainRpcUrls';
import {
  TESTNET_TOKEN_ARBITRUM_ETH,
  TESTNET_TOKEN_BIFROST_BFC,
  TESTNET_TOKEN_BSC_BNB,
  TESTNET_TOKEN_ETHEREUM_ETH,
  TESTNET_TOKEN_POLYGON_MATIC,
} from '../../tokens/testnetTokens';

// chain
export const TESTNET_CHAIN_BIFROST: Chain = {
  apiId: TESTNET_CHAIN_API_ID_BIFROST,
  id: TESTNET_CHAIN_ID_BIFROST,
  rpcUrls: TESTNET_CHAIN_RPC_URLS_BIFROST,
  explorerUrl: TESTNET_CHAIN_EXPLORER_URL_BIFROST,
  name: TESTNET_CHAIN_NAME_BIFROST,
  blockTerm: DEFAULT_BLOCK_TERM,
  gasFee: 1,
  coin: TESTNET_TOKEN_BIFROST_BFC,
};
export const TESTNET_CHAIN_ETHEREUM: Chain = {
  apiId: TESTNET_CHAIN_API_ID_ETHEREUM,
  id: TESTNET_CHAIN_ID_ETHEREUM,
  rpcUrls: TESTNET_CHAIN_RPC_URLS_ETHEREUM,
  explorerUrl: TESTNET_CHAIN_EXPLORER_URL_ETHEREUM,
  name: TESTNET_CHAIN_NAME_ETHEREUM,
  blockTerm: DEFAULT_BLOCK_TERM,
  gasFee: 0.001,
  coin: TESTNET_TOKEN_ETHEREUM_ETH,
};
export const TESTNET_CHAIN_ARBITRUM: Chain = {
  apiId: TESTNET_CHAIN_API_ID_ARBITRUM,
  id: TESTNET_CHAIN_ID_ARBITRUM,
  rpcUrls: TESTNET_CHAIN_RPC_URLS_ARBITRUM,
  explorerUrl: TESTNET_CHAIN_EXPLORER_URL_ARBITRUM,
  name: TESTNET_CHAIN_NAME_ARBITRUM,
  blockTerm: DEFAULT_BLOCK_TERM,
  gasFee: 0.001,
  coin: TESTNET_TOKEN_ARBITRUM_ETH,
};
export const TESTNET_CHAIN_POLYGON: Chain = {
  apiId: TESTNET_CHAIN_API_ID_POLYGON,
  id: TESTNET_CHAIN_ID_POLYGON,
  rpcUrls: TESTNET_CHAIN_RPC_URLS_POLYGON,
  explorerUrl: TESTNET_CHAIN_EXPLORER_URL_POLYGON,
  name: TESTNET_CHAIN_NAME_POLYGON,
  blockTerm: DEFAULT_BLOCK_TERM,
  gasFee: 0.1,
  coin: TESTNET_TOKEN_POLYGON_MATIC,
};
export const TESTNET_CHAIN_BSC: Chain = {
  apiId: TESTNET_CHAIN_API_ID_BSC,
  id: TESTNET_CHAIN_ID_BSC,
  rpcUrls: TESTNET_CHAIN_RPC_URLS_BSC,
  explorerUrl: TESTNET_CHAIN_EXPLORER_URL_BSC,
  name: TESTNET_CHAIN_NAME_BSC,
  blockTerm: DEFAULT_BLOCK_TERM,
  gasFee: 0.01,
  coin: TESTNET_TOKEN_BSC_BNB,
};
export const TESTNET_CHAIN_BASE: Chain = {
  apiId: TESTNET_CHAIN_API_ID_BASE,
  id: TESTNET_CHAIN_ID_BASE,
  rpcUrls: TESTNET_CHAIN_RPC_URLS_BASE,
  explorerUrl: TESTNET_CHAIN_EXPLORER_URL_BASE,
  name: TESTNET_CHAIN_NAME_BASE,
  blockTerm: DEFAULT_BLOCK_TERM,
  gasFee: 0.01,
};

export const TESTNET_CHAINS = [
  TESTNET_CHAIN_BIFROST,
  TESTNET_CHAIN_ETHEREUM,
  TESTNET_CHAIN_POLYGON,
  TESTNET_CHAIN_BSC,
  TESTNET_CHAIN_BASE,
];
